export default __webpack_public_path__ + "static/media/IconDesc_copper_new.64.4cf4585b.png";